import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, ControlItemsService, UserService,} from '../../_services/index';

import {AlertType, User} from '../../_models/index';

import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";


import {LoginHelper, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import {FormBuilder} from "@angular/forms";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import {IndexConfigService} from "../../_services/index.config.service";
import {TrustReportService} from "../../_services/trustreport.service";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "trustBuilder-invite-component",
  templateUrl: 'trustBuilder-invite.component.html',
  styleUrls: ['./trustBuilder-invite.component.scss'],
})

export class TrustBuilderInviteComponent implements OnInit {
  public selectDialogRef: MatDialogRef<SelectControlItemComponent>;
  api: string = window.location.origin;
  tenantName: string = LoginHelper.getTenantName();
  token: string = LoginHelper.getFileToken();
  users: User[] = [];
  assignedUsers: any[] = [];
  trustBuilderId: number;
  cols : any[] = [
    {'field': 'category', 'header': 'Category'},
    {'field': 'complianceAreaControlId', 'header': 'Control ID'},
    {'field': 'description', 'header': 'Description'}
  ];
  quiz: any;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public controlItemsService: ControlItemsService,
    public userService: UserService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<TrustBuilderInviteComponent>,
    @Inject(DOCUMENT) public document: any,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _formBuilder: FormBuilder,
    public config: IndexConfigService,
    public trustBuilderService: TrustReportService) {
  }

  ngOnInit() {
    this.userService.getAllShort().subscribe(u => {
      this.trustBuilderService.getTrustReportsById(this.data.trustBuilderId).subscribe(d => {
        this.quiz = d;
        const assignedIds = (this.quiz.trustBuilderUsers || []).map(i => i.userId);
        this.users = u.filter(u => u.role === Role.TrustCenterViewer);
        this.assignedUsers = this.users.filter(u => assignedIds.indexOf(u.userId) >= 0);
      });
    })
  }

  invite() {
    if (this.quiz.trustBuilderUsers.length == this.assignedUsers.length && !this.quiz.trustBuilderUsers.find(a => !this.assignedUsers.find(aa => a.userId == aa.userId)))
    {
      this.alertService.alert(AlertType.Error, "No changes were done");
      return;
    }
    this.quiz.trustBuilderUsers = this.assignedUsers.map(a => ({trustBuilderId: this.data.trustBuilderId, userId: a.userId}));
    this.trustBuilderService.updateTrustReport(this.quiz).subscribe(() => {
      this.trustBuilderService.updateList.next(true);
      this.dialogRef.close();
      this.alertService.success("User(s) successfully added");
    });
  }

  close() {
    this.dialogRef.close();
  }

  getFullName(user) {
    if (!user) {
      return '';
    }
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }
}
